import loginedApi, { FILEURL } from "../apis";
import CryptoJS from "crypto-js";
// import { USER_TOKEN } from "../constants/const";
import {
  convertDateToString,
  convertDateToStringOneYear,
  convertDateToStringThreeMonthBack,
} from "../Helpers/dateFunctions";
import { getFromLocalStorage } from "../Helpers/localStorageHelper";
import authHeader from "./AuthHeader";
import {
  INTERBRANCH_ADMIN_CONSOLIDATED,
  INTERBRANCH_ADMIN_DASHBOARD,
  INTERBRANCH_ADMIN_DASHBOARD_SELECTED,
  INTERBRANCH_ADMIN_DASHBOARD_SELECTED_v2,
  INTERBRANCH_ADMIN_DETAILED,
  INTERBRANCH_ADMIN_DETAILED_SELECTED,
  MANAGE_HOSPITALS_LIST,
  MANAGE_SESSION,
} from "./type";

import { ADMIN_USER, CLINIC_ADMIN, USER_DATA } from "../constants/const";

var hashcode = CryptoJS.SHA256(
  process.env.REACT_APP_PREFIX +
    process.env.REACT_APP_TOKEN +
    process.env.REACT_APP_SECRETKEY
);

let off = new Date().toString().replace(/GMT\+(\d\d)(\d\d)/, "GMT+$1:$2");
let formatTime = off?.split("GMT")[1].split(" (")[0];
let result = formatTime?.slice(1);
if (formatTime.search(/\+/g) != null) {
  formatTime = formatTime.replace(/\+/g, "%2B");
} else if (formatTime.search(/\-/g) != null) {
  formatTime = formatTime.replace(/\-/g, "%2D");
} //replace(/\+/g,' ') browserTimeZone: `GMT${formatTime}`

export const FETCH_ADMIN_DASHBOARD_REPORT =
  (
    _para,
    offset,
    doctorSearch,
    finalDate,
    appointmentStatus,
    patientName,
    patientNumber,
    patientEmail,
    department,
    specialityvalue
  ) =>
  async (dispatch) => {
    // let userToken = await getFromLocalStorage(USER_TOKEN)

    console.log("FETCH_ADMIN_DASHBOARD_REPORT", _para?.operation);

    let params = {
      token: hashcode.toString(),
      requestType: "518",
      version: "2.0",
      data: {
        operation: _para?.operation ? _para?.operation : "start",
        browserTimeZone: `GMT${formatTime}`,
        Type: "C",
        clinicId: _para?.clinicId ? _para.clinicId.toString() : "90",
        offset: offset != null ? offset : "0",
        // doctorId: selectedDoctorId,
        //    clinicId:"62",
      },
    };
    if (_para?.operation === "find") {
      params.data.startDate = _para.startDate;
      params.data.endDate = _para.endDate;
    }
    if (_para?.operation === "start") {
      params.data.operationDate = _para.operationDate;
    }
    if (doctorSearch != null) {
      params.data.doctorId = doctorSearch;
    }
    if (finalDate != null) {
      params.data.appointmentDate = finalDate;
    }
    if (appointmentStatus != null) {
      params.data.appointmentStatus = appointmentStatus;
    }
    if (patientName != null) {
      params.data.patientName = patientName;
    }
    if (patientNumber != null) {
      params.data.patientNumber = patientNumber;
    }
    if (patientEmail != null) {
      params.data.patientEmail = patientEmail;
    }
    if (department != null) {
      params.data.department = department;
    }
    if (specialityvalue != null) {
      params.data.speciality = specialityvalue;
    }
    console.log("params", params);
    let responce = await loginedApi.post("getappointments", params, {
      headers: authHeader(),
    });

    console.log("getappointments responce ->", responce.data.data);

    if (responce.status == 200) {
      dispatch({
        type: INTERBRANCH_ADMIN_DASHBOARD,
        payload: {
          data: responce.data.data,
          totalPages: responce.data.totalNumberOfPages,
        },
      });

      return responce.data;
    }
  };

export const FETCH_ADMIN_DETAILED_REPORT = (_para) => async (dispatch) => {
  let userData = await getFromLocalStorage(USER_DATA);
  userData = JSON.parse(userData);
  let { userType, clinicId } = userData;

  let todayDate = convertDateToString(new Date());
  let fromDate = _para?.fromDate ? convertDateToString(_para.fromDate) : null;
  let toDate = _para?.toDate ? convertDateToString(_para.toDate) : null;

  //console.log("Calling getsummaryreport................................................................... ->");

  let params = {
    token: hashcode.toString(),
    requestType: "1040",
    version: "2.0",
    data: {
      operation: "find",
      browserTimeZone: `GMT${formatTime}`,
      // "Type": "excel",
      startDate: fromDate
        ? fromDate
        : convertDateToStringThreeMonthBack(todayDate),
      endDate: toDate ? toDate : todayDate,
      offset: _para?.offset ? _para.offset.toString() : "0",
    },
  };

  if (userType == ADMIN_USER) {
  } else if (userType == CLINIC_ADMIN) {
    params.data.clinic = clinicId;
  }

  let response = await loginedApi.post("getsummaryreport", params, {
    headers: authHeader(),
  });

  //console.log("getsummaryreport responce ->", responce.data.data);

  if (response.status == "200") {
    if (response.data.errorType != "FAILURE" && response.data?.data) {
      dispatch({
        type: INTERBRANCH_ADMIN_DETAILED,
        payload: {
          data: response.data.data.data,
          totalPages: response.data.data.totalNumberOfPages,
        },
      });

      return response.data.data;
    } else {
      dispatch({ type: MANAGE_SESSION, payload: { isSessionActive: false } });
    }
  }
};

export const FETCH_DASHBOARD_MORE = (_id) => async (dispatch) => {
  let params = {
    token: hashcode.toString(),
    version: "2.0",
    requestType: "1101",
    data: { appointmentId: _id, browserTimeZone: `GMT${formatTime}` },
  };

  // console.log("Calling getappointments................................................................... ->");

  let response = await loginedApi.post("getappointmentsdetails", params, {
    headers: authHeader(),
  });

  if (response.status == "200") {
    if (response.data.errorType != "FAILURE" && response.data?.data) {
      dispatch({
        type: INTERBRANCH_ADMIN_DASHBOARD_SELECTED_v2,
        payload: response.data.data[0],
      });
      return response.data.data[0];
    } else {
      dispatch({ type: MANAGE_SESSION, payload: { isSessionActive: false } });
    }
  }
};

export const FETCH_DETAILED_MORE = (_id) => async (dispatch) => {
  let params = {
    token: hashcode.toString(),
    requestType: "1041",
    version: "2.0",
    data: {
      appointmentId: _id,
      browserTimeZone: `GMT${formatTime}`,
    },
  };

  let response = await loginedApi.post("getdetailreport", params, {
    headers: authHeader(),
  });

  if (response.status == "200") {
    if (response.data.errorType != "FAILURE" && response.data?.data) {
      dispatch({
        type: INTERBRANCH_ADMIN_DETAILED_SELECTED,
        payload: response.data.data,
      });
    } else {
      dispatch({ type: MANAGE_SESSION, payload: { isSessionActive: false } });
    }
  }
};

export const FETCH_CONSOLIDATED_REPORTS = (_para) => async (dispatch) => {
  let userData = await getFromLocalStorage(USER_DATA);
  userData = JSON.parse(userData);
  let { userType, clinicId } = userData;

  //console.log(_para);

  let todayDate = convertDateToString(new Date());

  let fromDate = _para?.fromDate
    ? convertDateToString(_para.fromDate)
    : convertDateToStringOneYear(todayDate);
  let toDate = _para?.endDate ? convertDateToString(_para.endDate) : todayDate;

  console.log(_para?.filterData);

  let params = {
    token: hashcode.toString(),
    requestType: "1040",
    version: "2.0",
    data: {
      // "operation": _para.filterData.date || _para.filterData.hospital? "filter" : "search",
      operation: "filter",
      browserTimeZone: `GMT${formatTime}`,
      Type: "excel",
      offset: _para?.offset ? _para.offset.toString() : "0",
    },
  };

  if (userType == CLINIC_ADMIN) {
    params.data.clinic = clinicId;
  }

  if (_para?.filterData) {
    if (_para.filterData.date && _para.filterData.hospital) {
      params.data["filterType"] = "all";
      params.data["filterMonthYear"] = _para.filterData.date;
      params.data["filterHospital"] = _para.filterData.hospital;
    } else if (_para.filterData.date) {
      params.data["filterType"] = "monthYear";
      params.data["filterMonthYear"] = _para.filterData.date;
    } else if (_para.filterData.hospital) {
      params.data["filterType"] = "hospital";
      params.data["filterHospital"] = _para.filterData.hospital;
    }
  }

  let response = await loginedApi.post("getconsolidatedreport", params, {
    headers: authHeader(),
  });

  console.log("getconsolidatedreport responce ->", response.data.data);

  if (response.status == "200") {
    if (response.data.errorType != "FAILURE" && response.data?.data) {
      dispatch({
        type: INTERBRANCH_ADMIN_CONSOLIDATED,
        payload: {
          data: response.data.data.data,
          totalPages: response.data.data.totalNumberOfPages,
        },
      });

      return true;
    } else {
      dispatch({ type: MANAGE_SESSION, payload: { isSessionActive: false } });
    }
  }
};

export const updateMisReportComment = (_id, value) => async (dispatch) => {
  let params = {
    token: hashcode.toString(),
    requestType: "1046",
    version: "2.0",
    data: {
      appointmentId: _id,
      notes: value,
    },
  };

  let response = await loginedApi.post("updatereportdata", params, {
    headers: authHeader(),
  });

  if (response.status == "200") {
    if (response.data.errorType != "FAILURE" && response.data?.data) {
      if (
        response.status == 200 &&
        response.data.data.info === "Successfully Updated"
      ) {
        return true;
      }
    } else {
      dispatch({ type: MANAGE_SESSION, payload: { isSessionActive: false } });
    }
  }
};

export const updateMisReportAttachments = (_id, value) => async (dispatch) => {
  let params = {
    token: hashcode.toString(),
    requestType: "1046",
    version: "2.0",
    data: {
      consolReportId: _id,
      uploadedFile: value,
    },
  };

  let response = await loginedApi.post("updateconsolreport", params, {
    headers: authHeader(),
  });

  if (response.status == "200") {
    if (response.data.errorType != "FAILURE" && response.data?.data) {
      if (
        response.status == 200 &&
        response.data.data.info === "Successfully Updated"
      ) {
        return true;
      }
    } else {
      dispatch({ type: MANAGE_SESSION, payload: { isSessionActive: false } });
    }
  }
};

export const updateConsolodatedReportComment =
  (_id, value) => async (dispatch) => {
    let params = {
      token: hashcode.toString(),
      requestType: "1046",
      version: "2.0",
      data: {
        consolReportId: _id,
        adjustments: value,
      },
    };

    let response = await loginedApi.post("updateconsolreport", params, {
      headers: authHeader(),
    });

    if (response.status == "200") {
      if (response.data.errorType != "FAILURE" && response.data?.data) {
        if (
          response.status == 200 &&
          response.data.data.info === "Successfully Updated"
        ) {
          return true;
        }
      } else {
        dispatch({ type: MANAGE_SESSION, payload: { isSessionActive: false } });
      }
    }
  };

export const downloadSummaryReport = (_para) => async (dispatch) => {
  let fromDate = _para?.fromDate
    ? convertDateToString(_para.fromDate)
    : convertDateToStringThreeMonthBack(convertDateToString(new Date()));
  let toDate = _para?.toDate
    ? convertDateToString(_para.toDate)
    : convertDateToString(new Date());

  let userData = await getFromLocalStorage(USER_DATA);
  userData = JSON.parse(userData);
  let { userType, clinicId } = userData;

  //console.log(fromDate, toDate);

  let params = {
    token: hashcode.toString(),
    requestType: "1040",
    version: "2.0",
    data: {
      operation: "find",
      browserTimeZone: `GMT${formatTime}`,
      Type: "excel",
      startDate: fromDate,
      endDate: toDate,
    },
  };

  if (userType == ADMIN_USER) {
  } else if (userType == CLINIC_ADMIN) {
    params.data.clinic = clinicId;
  }

  let response = await loginedApi.post("getsummaryreport", params, {
    headers: authHeader(),
  });

  //console.log("getsummaryreport responce ->", responce.data.data);

  if (response.status == "200") {
    if (response.data.errorType != "FAILURE" && response.data?.data) {
      if (response.data?.data?.filename) {
        return (
          FILEURL +
          `?requestType=256&uploadBy=ConsultationProcess&name=${response.data?.data?.filename}&type=Attachement&uploadRefId=123&from=web`
        );
      }
    } else {
      dispatch({ type: MANAGE_SESSION, payload: { isSessionActive: false } });
    }
  }
};

export const downloadAppointmentReport = (_para) => async (dispatch) => {
  let fromDate = _para?.fromDate
    ? convertDateToString(_para.fromDate)
    : convertDateToString(new Date());
  let toDate = _para?.toDate
    ? convertDateToString(_para.toDate)
    : convertDateToString(new Date());

  let userData = await getFromLocalStorage(USER_DATA);
  userData = JSON.parse(userData);
  let { userType, clinicId } = userData;

  //console.log(fromDate, toDate);

  let params = {
    token: hashcode.toString(),
    requestType: "518",
    version: "2.0",
    data: {
      operation: _para?.operation,
      browserTimeZone: `GMT${formatTime}`,
      Type: "excel",
      clinicId: _para?.clinicId ? _para.clinicId.toString() : "20",
      // clinicId:_para?.clinicId ? _para.clinicId.toString() : "20",
      // clinicId:"62"

      //doctorId: _para.doctorId,
    },
  };
  if (userType == ADMIN_USER) {
  } else if (userType == CLINIC_ADMIN) {
    params.data.clinic = clinicId;
  }

  if (_para?.operation === "find") {
    params.data.startDate = _para.startDate;
    params.data.endDate = _para.endDate;
  }
  if (_para?.operation === "start") {
    params.data.operationDate = _para.operationDate;
  }

  if (_para.doctorId != null) {
    params.data.doctorId = _para.doctorId;
  }
  if (_para.appointmentDate != null) {
    params.data.appointmentDate = _para.appointmentDate;
  }
  if (_para.appointmentStatus != null) {
    params.data.appointmentStatus = _para.appointmentStatus;
  }
  if (_para.patientName != null) {
    params.data.patientName = _para.patientName;
  }
  if (_para.patientNumber != null) {
    params.data.patientNumber = _para.patientNumber;
  }
  if (_para.patientEmail != null) {
    params.data.patientEmail = _para.patientEmail;
  }
  if (_para.department != null) {
    params.data.department = _para.department;
  }
  if (_para.speciality != null) {
      params.data.speciality = _para.speciality;
    }
  let response = await loginedApi.post("getappointments", params, {
    headers: authHeader(),
  });

  //console.log("getsummaryreport responce ->", responce.data.data);

  if (response.status == "200") {
    if (response.data.errorType != "FAILURE" && response.data?.data) {
      if (response.data?.data?.filename) {
        return (
          FILEURL +
          `?requestType=256&uploadBy=ConsultationProcess&name=${response.data?.data?.filename}&type=Attachement&uploadRefId=123&from=web`
        );
      }
    } else {
      dispatch({ type: MANAGE_SESSION, payload: { isSessionActive: false } });
    }
  }
};

export const downloadAppointmentRequestreport = (_para) => async (dispatch) => {
  let fromDate = _para?.fromDate
    ? convertDateToString(_para.fromDate)
    : convertDateToStringThreeMonthBack(convertDateToString(new Date()));
  let toDate = _para?.toDate
    ? convertDateToString(_para.toDate)
    : convertDateToString(new Date());

  let userData = await getFromLocalStorage(USER_DATA);
  userData = JSON.parse(userData);
  let { userType, clinicId } = userData;

  //console.log(fromDate, toDate);

  let params = {
    token: hashcode.toString(),
    requestType: "524",
    version: "2.0",
    data: {
      operation: "find",
      clinicId: "62",
      offset: 0,
      browserTimeZone: `GMT${formatTime}`,
      Type: "excel",
      filterType: _para?.filterType,
      filterBy: _para?.filterBy,
      startDate: fromDate,
      endDate: toDate,
    },
  };

  if (userType == ADMIN_USER) {
  } else if (userType == CLINIC_ADMIN) {
    params.data.clinic = clinicId;
  }

  let response = await loginedApi.post("getappointmentrequests", params, {
    headers: authHeader(),
  });
  console.log("id", _para?.requestId);
  console.log("getsummaryreport responce ->", response.data?.data?.filename);

  if (response.status == "200") {
    if (response.data.errorType != "FAILURE" && response.data.data) {
      console.log(
        "response.data?.data?.filename",
        response.data?.data?.filename
      );
      if (response.data.data.filename) {
        //return response.data.data.filename
        return (
          FILEURL +
          `?requestType=256&uploadBy=ConsultationProcess&name=${response.data?.data?.filename}&type=Attachement&uploadRefId=123&from=web`
        );
      }
    } else {
      dispatch({ type: MANAGE_SESSION, payload: { isSessionActive: false } });
    }
  }
};

export const getHospitalsList = () => async (dispatch) => {
  let params = {
    token: hashcode.toString(),
    requestType: "1111",
    data: { browserTimeZone: "GMT+05:30" },
  };

  let response = await loginedApi.post("gethospitals", params, {
    headers: authHeader(),
  });

  // console.log("gethospitals response===>", response);

  dispatch({
    type: MANAGE_HOSPITALS_LIST,
    payload: response.data.data,
  });
};

export const fetchLatestAppointments = () => async (dispatch) => {
  let res = await loginedApi.post("fetchlatestappointments", {
    token: hashcode.toString(),
    data: {
      Type: "",
      browserTimeZone: `GMT${formatTime}`,
    },
    requestType: 508,
  });
  console.debug("fetchlatestappointments", res.data.data);
  return res.data.data;
};

export const fetchLatestRequestedAppointments = () => async (dispatch) => {
  let res = await loginedApi.post("fetchlatestappointmentrequests", {
    token: hashcode.toString(),
    data: {
      Type: "",
      browserTimeZone: `GMT${formatTime}`,
    },
    requestType: 508,
  });
  console.debug("fetchlatestappointments", res.data.data);
  return res.data.data;
};

export const fetchCountofConsultations = (filterBy) => async (dispatch) => {
  let res = await loginedApi.post("fetchcountofconsultations", {
    token: hashcode.toString(),
    data: {
      filterBy: filterBy,
      browserTimeZone: `GMT${formatTime}`,
    },
    requestType: 508,
  });
  console.debug("fetchlatestappointments", res.data.data);
  return res.data.data;
};

export const getCountOfDetails = () => async (dispatch) => {
  let res = await loginedApi.post("getcountofdetails", {
    token: hashcode.toString(),
    data: {
      filterBy: "",
      browserTimeZone: `GMT${formatTime}`,
    },
    requestType: 508,
  });
  console.debug("fetchlatestappointments", res.data.data);
  return res.data.data;
};

export const fetchConsolidatedAnalytics = (filterBy) => async (dispatch) => {
  let res = await loginedApi.post("fetchconsolidatedanalytics", {
    token: hashcode.toString(),
    data: {
      filterBy: filterBy,
      browserTimeZone: `GMT${formatTime}`,
    },
    requestType: 508,
  });
  console.debug("fetchlatestappointments", res.data.data);
  return res.data.data;
};
